<!-- AnnotationProperties — clone of Magic Patterns media/AnnotationProperties.tsx -->
<div class="apr">
  <div class="apr__head">
    <div class="apr__title"><span class="apr__dot" [style.background]="annotation.color"></span>{{ title }} Properties</div>
    <button type="button" class="apr__close" (click)="close.emit()"><mat-icon>close</mat-icon></button>
  </div>

  <div class="apr__body">
    <div class="apr__meta">
      <div class="apr__meta-row"><mat-icon>person</mat-icon> Created by {{ annotation.author }}</div>
      <div class="apr__meta-row"><mat-icon>schedule</mat-icon> {{ when }}</div>
    </div>

    <div class="apr__field">
      <label>Description</label>
      <textarea rows="3" [value]="annotation.description || ''"
                (input)="setDescription($any($event.target).value)"
                placeholder="Add a note about this annotation…"></textarea>
    </div>

    <div class="apr__field">
      <label>Opacity — {{ ((annotation.opacity == null ? 1 : annotation.opacity) * 100) | number:'1.0-0' }}%</label>
      <input type="range" min="0.1" max="1" step="0.1" [value]="annotation.opacity == null ? 1 : annotation.opacity"
             (input)="setOpacity(+$any($event.target).value)">
    </div>

    <div class="apr__field">
      <label>Stroke Width — {{ annotation.strokeWidth }}px</label>
      <input type="range" min="1" max="20" step="1" [value]="annotation.strokeWidth"
             (input)="setStroke(+$any($event.target).value)">
    </div>

    <div class="apr__field" *ngIf="isShape">
      <label>Fill Color</label>
      <div class="apr__fills">
        <button type="button" class="apr__fill apr__fill--none" [class.is-active]="!annotation.fillColor"
                (click)="setFill(undefined)" title="No fill"><mat-icon>block</mat-icon></button>
        <button type="button" class="apr__fill" *ngFor="let c of fillColors"
                [class.is-active]="annotation.fillColor === c" [style.background]="c" (click)="setFill(c)"></button>
      </div>
    </div>

    <div class="apr__measure" *ngIf="isMeasure">
      <label>Measurement</label>
      <div class="apr__measure-val">{{ (annotation.measurementValue || 0) | number:'1.1-1' }} {{ annotation.measurementUnit || 'm' }}</div>
    </div>

    <div class="apr__actions">
      <button type="button" class="apr__lock" (click)="toggleLock()">
        <mat-icon>{{ annotation.locked ? 'lock' : 'lock_open' }}</mat-icon>
        {{ annotation.locked ? 'Unlock Annotation' : 'Lock Annotation' }}
      </button>
      <button type="button" class="apr__delete" (click)="deleteAnnotation.emit()">
        <mat-icon>delete</mat-icon> Delete Annotation
      </button>
    </div>
  </div>
</div>
